export default __webpack_public_path__ + "static/media/artificialIntelligenceOff.38ce9bdf.svg";